import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface AuthShellProps {
  title: string;
  subtitle?: string;
  children: ReactNode;
  footer?: ReactNode;
}

export function AuthShell({ title, subtitle, children, footer }: AuthShellProps) {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <header className="h-14 flex items-center px-6 border-b border-border">
        <Link to="/login" className="text-sm font-semibold">
          Babilu
        </Link>
      </header>

      <main className="flex-1 flex items-center justify-center px-6 py-12">
        <div className="w-full max-w-sm space-y-8">
          <div className="space-y-1.5 text-center">
            <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
            {subtitle && <p className="text-sm text-muted-foreground">{subtitle}</p>}
          </div>

          {children}

          {footer && <p className="text-center text-sm text-muted-foreground">{footer}</p>}
        </div>
      </main>

      <footer className="h-12 flex items-center justify-center text-xs text-muted-foreground border-t border-border">
        © 2026 Babilu App
      </footer>
    </div>
  );
}
